'use client';

export type PreparedNangoPopup = {
  popupWindow: Window | null;
  cleanup: () => void;
  close: () => void;
};

export function prepareNangoPopup(): PreparedNangoPopup {
  const popupState = window as typeof window & {
    __originalWindowOpen?: typeof window.open;
    __oauthPopup?: Window | null;
  };

  if (!popupState.__originalWindowOpen) {
    popupState.__originalWindowOpen = window.open;
  }

  if (popupState.__oauthPopup && !popupState.__oauthPopup.closed) {
    try {
      popupState.__oauthPopup.close();
    } catch {
      // Ignore errors when closing stale OAuth popups.
    }
  }

  if (popupState.__originalWindowOpen) {
    window.open = popupState.__originalWindowOpen;
  }

  const popupWindow = window.open('', '_blank', 'width=500,height=600,left=200,top=100');
  let preparedWindowOpen: typeof window.open | null = null;

  const cleanup = () => {
    if (
      preparedWindowOpen &&
      window.open === preparedWindowOpen &&
      popupState.__originalWindowOpen
    ) {
      window.open = popupState.__originalWindowOpen;
    }
    if (popupState.__oauthPopup === popupWindow || popupState.__oauthPopup?.closed) {
      delete popupState.__oauthPopup;
    }
  };

  if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === 'undefined') {
    return {
      popupWindow: null,
      cleanup,
      close: cleanup,
    };
  }

  popupState.__oauthPopup = popupWindow;
  const trueOriginal = popupState.__originalWindowOpen;

  preparedWindowOpen = (url?: string | URL, target?: string, features?: string) => {
    if (target === '_blank' || target === '' || !target) {
      if (url && url !== '') {
        popupWindow.location.href = url as string;
      }
      return popupWindow;
    }

    return trueOriginal!.call(window, url, target, features);
  };
  window.open = preparedWindowOpen;

  return {
    popupWindow,
    cleanup,
    close: () => {
      if (!popupWindow.closed) {
        popupWindow.close();
      }
      cleanup();
    },
  };
}
